module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-5 ovf-hd"
  }, [_c('div', {
    staticClass: "fl m-r-30"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("添加常用语")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fl w-260"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    },
    slot: "append"
  })], 1)], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.page_height,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "编号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "内容",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#0c0"
          }
        }, [_vm._v("正常")]) : (scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#bb0"
          }
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : (scope.row.status == -1) ? _c('span', {
          staticStyle: {
            "color": "#d00"
          }
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('span', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.update(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDelete(scope.row)
            }
          }
        }, [_vm._v("删除")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": 'used'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加常用语",
      "visible": _vm.open_add,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.open_add = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "20%",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "常用语",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.value),
      callback: function($$v) {
        _vm.$set(_vm.form, "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.value"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.open_add = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a6c99972!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/used/list.vue
// module id = 1870
// module chunks = 2